<template>
  <div
    id="app"
    :style="
      shouldDisplayNonPrintComponent
        ? {}
        : { margin: 0, padding: 0, overflow: 'initial' }
    "
  >
    <s-menu v-if="shouldDisplay"></s-menu>
    <phil-collins v-if="shouldDisplay"></phil-collins>
    <main
      class="Main"
      :style="
        shouldDisplayNonPrintComponent
          ? {}
          : { margin: 0, padding: 0, overflow: 'initial' }
      "
    >
      <router-view />
    </main>
    <basket v-if="shouldDisplay" />
  </div>
</template>

<script>
import SMenu from "./components/SMenu";
import PhilCollins from "./components/ScaryModal";
import Basket from "./components/Basket/Basket";
import { authRoutesRegex, printRoutesRegex, identity } from "./util/func";
import { types as authTypes } from "./store/actions/auth";

export default {
  name: "Genesis",
  components: { Basket, PhilCollins, SMenu },
  computed: {
    shouldDisplay() {
      return [
        this.shouldDisplayNonAuthComponent,
        this.shouldDisplayNonPrintComponent
      ].every(identity);
    },
    shouldDisplayNonPrintComponent() {
      return !printRoutesRegex.test(this.$route.path);
    },
    shouldDisplayNonAuthComponent() {
      return !authRoutesRegex.test(this.$route.path);
    }
  },
  async mounted() {
    if (!window.HEADLESS) {
      try {
        this.$store.dispatch(authTypes.VERIFY);
      } catch (e) {
        this.$store.dispatch(authTypes.LOGOUT, this.router);
      }
    }
  }
};
</script>

<style lang="scss">
@import "assets/bulma";
@import "assets/fontawesome-free/css/solid.min.css";
@import "assets/fontawesome-free/css/fontawesome.min.css";
@import "assets/fonts/synthese.scss";

html,
body {
  font-family: "IBM Plex Mono", sans-serif;
  font-weight: 500;
}

.box.box-small {
  padding: 0.25em;
}

html {
  background: #eee;
}

html,
body,
#app {
  width: 100%;
}

#app {
  display: flex;
}

.app {
  padding: 3em;
  height: 100%;

  &__left {
    flex: 1 0 200px;
    height: 100%;
  }

  &__right {
    width: 100%;
    padding-left: 4em;
  }
}

a {
  text-decoration: underline;
}

.pointer {
  cursor: pointer;
}

.dimmed {
  opacity: 0.5;
  pointer-events: none;
}

.input,
.label,
.button {
  @extend .is-small;
}

.SMenu {
  padding: 1em;
  flex: 0 0 240px;
  margin-right: 1em;
  border-right: 1.5px solid lightgrey;
  position: sticky;
  top: 0;
  height: 100vh;
}

.Main {
  padding: 1em;
  flex-grow: 1;
  position: relative;
  padding-right: 4em;

  & > div {
    padding-bottom: 5em;
    max-width: 1280px;
  }

  @media print {
    margin: 0;
    padding: 0;
    overflow: initial;
  }
}

.mc {
  max-width: 767px;
}

.flex {
  display: flex;
}

.serif {
  font-family: serif;
}

@media print {
  .noprint {
    display: none;
  }
  html,
  body,
  .Space,
  .PPage {
    background: none !important;
  }
}

a {
  color: black;
  text-decoration-color: black;

  &:hover {
    color: #0002bb;
  }

  &.button {
    text-decoration: none;
  }
}

@import "./styles/index.scss";

.button,
.file-cta,
.file-name,
.input,
.pagination-ellipsis,
.pagination-link,
.pagination-next,
.pagination-previous,
.select,
select,
.textarea,
body,
button,
input,
select,
textarea {
  font-family: inherit;
}
</style>
